import NegatifIcon from '@/assets/Negatif-icon.svg?react'
import NetralIcon from '@/assets/Netral-icon.svg?react'
import PositifIcon from '@/assets/Positif-green-icon.svg?react'

interface Props {
  item: string
}
const SentimentIcon = ({ item }: Props) => {
  switch (item) {
    case 'positive':
      return <PositifIcon />
    case 'negative':
      return <NegatifIcon />
    case 'above':
      return <PositifIcon />
    case 'below':
      return <NegatifIcon />
    case 'neutral':
      return <NetralIcon />

    default:
      break
  }
}

export default SentimentIcon
